export const config = {
  appName: "Malhotra's Financial Vault",
  shortName: "MFV",
  timeZone: 'Australia/Sydney',
  locale: 'en-AU',
  theme: {
    primary: '#102D4C',
    darkNav: '#0B2138',
    supportNav: '#173B61',
    gold: '#B98937',
    goldHover: '#C99A3D',
    goldDark: '#9B702A',
    goldLight: '#E3C684',
    goldSelected: '#FFF7E6',
    teal: '#0F766E',
  },
  navigation: [
    { label: 'Dashboard', path: '/' },
    { label: 'Profiles', path: '/profiles' },
    { label: 'Documents', path: '/documents' },
    { label: 'Reports', path: '/reports' },
    { label: 'Settings', path: '/settings' },
  ],
  connectedApps: [
    { name: 'Malhotra Property Portfolio', url: 'https://mpp.bpasolutions.au/', icon: 'property' },
    { name: 'BPAS Invoice Flow', url: 'https://melodic-bavarois-3fcdd8.netlify.app/', icon: 'invoice' },
    { name: 'BPAS Core Ledger', url: 'https://celebrated-platypus-c1bb9d.netlify.app/', icon: 'ledger' },
    { name: 'File Compressor', url: 'https://app.bpasolutions.au/SafePDF-local', icon: 'compressor' },
  ] as const,
  profileTypes: ['Individual', 'Joint', 'Company', 'Business', 'SMSF'] as const,
  financialYearStatuses: ['In Progress', 'Lodged', 'Finalised'] as const,
  referenceBlockTypes: [
    'Tax details',
    'Identity details',
    'Business details',
    'Accountant details',
    'Custom',
  ] as const,
  documentCategories: [
    'Tax Return',
    'Notice of Assessment',
    'Auditor Report',
    'Bank Statement',
    'Receipt',
    'Financial Statement',
    'BAS',
    'Invoice',
  ],
  dormantModules: [
    'Assets and liabilities',
    'Insurance register',
    'Loans and facilities',
    'Estate records',
    'Accountant request tracker',
    'Secure sharing',
    'AI document classification',
  ],
  features: {
    searchEnabled: true,
    uploadEnabled: true
  },
  limits: {
    profileNotes: 10000,
    annualSummary: 20000,
    documentTitle: 250,
    documentNotes: 10000,
    documentTag: 60,
  },
  upload: {
    maxFileSize: 5 * 1024 * 1024,
    maxFileSizeLabel: '5 MB',
    concurrency: 3,
    allowedExtensions: ['.pdf', '.jpg', '.jpeg', '.png', '.webp', '.csv', '.xls', '.xlsx', '.doc', '.docx'],
    mimeMap: {
      pdf: 'application/pdf',
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      png: 'image/png',
      webp: 'image/webp',
      csv: 'text/csv',
      xls: 'application/vnd.ms-excel',
      xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      doc: 'application/msword',
      docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    } as Record<string, string>,
    acceptAttribute: '.pdf,.jpg,.jpeg,.png,.webp,.csv,.xls,.xlsx,.doc,.docx',
  },
  searchSynonyms: {
    'itr': 'Tax Return',
    'income tax return': 'Tax Return',
    'noa': 'Notice of Assessment',
    'assessment': 'Notice of Assessment',
    'bas': 'BAS',
    'bank stmt': 'Bank Statement',
    'bank statement': 'Bank Statement',
    'statement': 'Bank Statement',
    'financials': 'Financial Statement',
    'financial statement': 'Financial Statement',
    'auditor': 'Auditor Report',
    'auditor report': 'Auditor Report',
    'receipt': 'Receipt',
    'invoice': 'Invoice',
  } as Record<string, string>,
  searchCommands: [
    { title: 'Dashboard', route: '/', subtitle: 'Navigation' },
    { title: 'Profiles', route: '/profiles', subtitle: 'Navigation' },
    { title: 'Documents', route: '/documents', subtitle: 'Navigation' },
    { title: 'Reports', route: '/reports', subtitle: 'Navigation' },
    { title: 'Settings', route: '/settings', subtitle: 'Navigation' },
    { title: 'Help & Guide', route: '/settings/guide', subtitle: 'Navigation' },
    { title: 'Upload Document', route: 'upload', subtitle: 'Action' },
    { title: 'Add Profile', route: '/profiles', subtitle: 'Action' },
    { title: 'Add Financial Year', route: '/', subtitle: 'Action' },
  ],
};